import { render, staticRenderFns } from "./DetailsDialog.vue.vue?vue&type=template&id=230516a5&scoped=true&"
import script from "./DetailsDialog.vue.vue?vue&type=script&lang=js&"
export * from "./DetailsDialog.vue.vue?vue&type=script&lang=js&"
import style0 from "./DetailsDialog.vue.vue?vue&type=style&index=0&id=230516a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230516a5",
  null
  
)

export default component.exports